import withHelmet from '../HOC/withHelmet';
import Follow from '../components/follow';

export default withHelmet(Follow, 'Follow Us on Social Media');
